import * as React from "react"
import * as ReactDOM from "react-dom"
import { createStore, applyMiddleware, compose } from "redux"
import { Provider } from "react-redux"
import { Router, browserHistory} from "react-router"
import thunk from "redux-thunk"
import * as createLogger from "redux-logger"
import {store} from "./reducers/AllReducer"
import routes from "./routes"

import * as TS_NameOf from "ts-nameof";      // NOTE: Do not Remove this import.
                                             // It creates a reference and injects "nameof" function in global context to be used by other files.

// // Init Sentry only for production
// if (process.env.NODE_ENV === "production") {
//     require("./sentry");
// }

require("./MixPanel")

// Prealoading data :
ReactDOM.render(
    <Provider store={store}>
        { /* Tell the Router to use our enhanced history */ }
            <Router history={browserHistory} routes={routes}/>
    </Provider>,
    document.getElementById("main")
);